import http from './http-common';
import { AxiosResponse } from 'axios';
import {
  GooglePlaceDetails,
  GooglePlacePrediction,
  ValidatedAddress,
  PostalAddress,
} from '../types/google-maps';

class GoogleMapsService {
  async getPredictionsForGoogleAddress(
    address: string,
  ): Promise<AxiosResponse<GooglePlacePrediction[]>> {
    return http.post('/google-maps/predictions', { address });
  }

  async getPlaceDetailsForGooglePlaceId(
    placeId: string,
  ): Promise<AxiosResponse<GooglePlaceDetails>> {
    return http.post('/google-maps/place-details', { placeId });
  }

  async getVerifiedAddress(address: any): Promise<AxiosResponse<ValidatedAddress>> {
    return http.post('/google-maps/verified-address', { address });
  }

  async validateAddressWithGoogle(address: PostalAddress) {
    const response = googleMapsService.getVerifiedAddress(address);
    return response;
  }

  parseAddressFromGoogleValidateResponse = (postalAddress: PostalAddress) => {
    return {
      address1: postalAddress.addressLines[0],
      address2: postalAddress.addressLines[1],
      city: postalAddress.locality,
      state: postalAddress.administrativeArea,
      zipcode: postalAddress.postalCode.slice(0, 5),
    };
  };
}

const googleMapsService = new GoogleMapsService();
export default googleMapsService;
